import Logger from '@utils/log'
import ParseAPI from '@api/ParseAPI'
import * as store from '@store'

const log = new Logger('actions/chainer')

export const addFailedChainTry = runsheetOrTabId => {
    
    const chainData = { ...store.runsheetTriedChaining.getValue() }
    
    chainData[runsheetOrTabId] = true
    store.runsheetTriedChaining.setValue(chainData)
    
}

export const removeFailedChainTry = runsheetOrTabId => {
    
    const chainData = { ...store.runsheetTriedChaining.getValue() }
    
    delete chainData[runsheetOrTabId]
    store.runsheetTriedChaining.setValue(chainData)
    
}

export const bulkChainRunsheet = async (runsheetId, fundingSource) => {
    
    try {
        
        const res = await ParseAPI.post(`chainer/${runsheetId}/bulk?fundingSource=${fundingSource}`)
        
        return res.data
        
    } catch (error) {
        
        log.e(error)
        
        throw error
        
    }
    
}

export const getChainsFromRunsheet = async runsheetId => {
    try {
        
        const res = await ParseAPI.get(`chainer/runsheet/${runsheetId}`)
        
        const currentRunsheet = store.currentRunsheet.getValue()
        
        if (currentRunsheet) {
            
            currentRunsheet.chains = res.data
            store.currentRunsheet.setValue({ ...currentRunsheet })
        }
        
        return res.data
        
    } catch (error) {
        
        log.e(error)
        
        throw error
        
    }
    
}